import React, { ReactElement, ReactNode, useState } from "react";
import { StarFilledIcon, StarIcon } from "../Icon/Icon";
interface RatingProps {
  onChange?: (i: number) => void;
  value?: number;
  max?: number;
  icon?: ReactNode;
  emptyIcon?: ReactNode;
  wrapperStyle?: React.CSSProperties;
}
export const Rating: React.FunctionComponent<RatingProps> = ({
  onChange,
  value = 0,
  max = 5,
  icon = <StarFilledIcon></StarFilledIcon>,
  emptyIcon = <StarIcon></StarIcon>,
  wrapperStyle = { display: "flex" },
}) => {
  const [currentHover, setCurrentHover] = useState(0);
  const stars: ReactElement[] = [];
  const hovering = currentHover !== 0;

  let iconStyleActive;
  let iconStyleInactive;

  // if we set the value, reset the hover
  const OnChangeResetHover = (i: number) => {
    setCurrentHover(0);
    if (onChange) {
      onChange(i);
    }
  };

  // in case onChange is undefined, we make the deactivate the hover
  if (hovering && onChange) {
    value = currentHover;
    iconStyleActive = {
      opacity: 0.8,
    };
    iconStyleInactive = {
      opacity: 0.5,
    };
  } else {
    iconStyleActive = {
      opacity: 1,
    };
    iconStyleInactive = {
      opacity: 0.5,
    };
  }

  for (let i = 1; i <= max; i++) {
    const active = i <= value;

    stars.push(
      <span
        key={i}
        onClick={() => OnChangeResetHover(i)}
        onMouseEnter={() => setCurrentHover(i)}
        onMouseLeave={() => setCurrentHover(0)}
        style={active ? iconStyleActive : iconStyleInactive}
      >
        <span className="mr-2">{active ? icon : emptyIcon}</span>
      </span>
    );
  }
  return <div style={wrapperStyle}>{stars}</div>;
};
